export default "__VITE_ASSET__15dc3ffd__"